import React from 'react'

const ViewToggle = ({children, isMobile, mobileClasses = 'mobile', desktopClasses = ''}) => (
    <div className={isMobile ? mobileClasses : desktopClasses}>
        {children}
    </div>
)

export default ViewToggle



// WEBPACK FOOTER //
// ./src/components/subcomponents/ViewToggle.js